import React, {useEffect} from 'react';
import { useHistory } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";

import Toolbar from "@material-ui/core/Toolbar";
// @material-ui/icons components
import MenuIcon from "@material-ui/icons/Menu";
import ZoomIn from "@material-ui/icons/ZoomIn";

// core components
//import AppsDropdown from "components/Dropdowns/AppsDropdown.js";
//import NotificationsDropdown from "components/Dropdowns/NotificationsDropdown.js";
import UserDropdown from "components/Dropdowns/UserDropdown.js";




// core components
import componentStyles from "assets/theme/components/navbars/admin-navbar.js";
import { Typography } from '@material-ui/core';


const useStyles = makeStyles(componentStyles);

export default function AdminNavbar({ openSidebarResponsive }) {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const [showSearch, setShowSearch] = React.useState(false);
  const [role, setrole] = React.useState("");


  useEffect(() => {
    var token = localStorage.getItem("token")

    const fetchData = async () => {
      try {
        const res = await fetch('https://server.thelanofficial.com/privilege', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ token })
        });

        if (!res.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await res.json();
        if(data.valid === false){
          history.push("/auth/login")
        }else{
            setrole(data.privilege)

          
        }
        
      } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
      }
    };

    fetchData();
  }, []);
  
  return (
    <>
      <AppBar
        position="relative"
        elevation={0}
        classes={{ root: classes.appBarRoot }}
      >
        <Toolbar disableGutters>
          <Container
            maxWidth={false}
            component={Box}
            classes={{ root: classes.containerRoot }}
          >
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              width="100%"
              marginTop="1rem"
              marginBottom="1rem"
            >
              <Box
                display="flex"
                alignItems="center"
                width="auto"
                marginRight="1rem"
               
              >
                <Typography style={{color:"#f77f23",fontSize:"30px", fontFamily:"Libre Franklin", fontWeight:"bold"}}>WELCOME , &nbsp;</Typography>
                <Typography style={{color:"#f77f23",fontSize:"30px", fontFamily:"Libre Franklin", fontWeight:"bold",textTransform: "uppercase"}}>{role} </Typography>
              </Box>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                marginLeft="auto"
                className={clsx(classes.marginLeftNone, {
                  [classes.displayNone]: showSearch,
                })}
              >
                <Hidden xlUp implementation="css">
                  <IconButton onClick={openSidebarResponsive}>
                    <Box
                      component={MenuIcon}
                      color={theme.palette.white.main}
                      width="1.5rem!important"
                      height="1.5rem!important"
                    />
                  </IconButton>
                </Hidden>
                <Hidden smUp implementation="css">
                  <IconButton onClick={() => setShowSearch(true)}>
                    <Box
                      component={ZoomIn}
                      color={theme.palette.white.main}
                      width="1.5rem!important"
                      height="1.5rem!important"
                    />
                  </IconButton>
                </Hidden>
               
              </Box>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                className={clsx(classes.marginLeftAuto, {
                  [classes.displayNone]: showSearch,
                })}
              >
                <UserDropdown />
              </Box>
            </Box>
          </Container>
        </Toolbar>
      </AppBar>
    </>
  );
}
AdminNavbar.defaultProps = {
  openSidebarResponsive: () => {},
};

AdminNavbar.propTypes = {
  // use this to make the Sidebar open on responsive mode
  openSidebarResponsive: PropTypes.func.isRequired,
};
